import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=d88752d8"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports